// Mock data for Yoshitaka Karate-Do clone

export const SITE = {
  name: "Yoshitaka Karate-Do",
  email: "yoshitakachicago@yahoo.com",
  phone: "(708) 612-0023",
  logoUrl: "/images/logo.jpg",
};

export const NAV_LINKS = [
  { key: "home", to: "/" },
  { key: "about", to: "/about" },
  { key: "gallery", to: "/gallery" },
  { key: "contact", to: "/contact" },
];

export const IMAGES = {
  main: "/images/sensei.jpg",
  about: "/images/nguyen-hung.jpg",
  classImg: "/images/sam-moghadam.jpg",
};

// Gallery images (locally bundled - CORS-safe). captionKey resolves via i18n.
export const GALLERY = [
  { id: 1, src: "/images/dojo1.webp", captionKey: "dojo1" },
  { id: 2, src: "/images/dojo2.webp", captionKey: "dojo2" },
  { id: 3, src: "/images/dojo3.webp", captionKey: "dojo3" },
  { id: 4, src: "/images/dojo4.webp", captionKey: "dojo4" },
  { id: 5, src: "/images/dojo5.webp", captionKey: "dojo5" },
  { id: 6, src: "/images/kids1.webp", captionKey: "kids1" },
  { id: 7, src: "/images/kids2.webp", captionKey: "kids2" },
  { id: 8, src: "/images/karate1.png", captionKey: "karate1" },
  { id: 9, src: "/images/sensei.jpg", captionKey: "sensei" },
  { id: 10, src: "/images/nguyen-hung.jpg", captionKey: "nguyen" },
  { id: 11, src: "/images/sam-moghadam.jpg", captionKey: "sam" },
  { id: 12, src: "/images/g1.jpg", captionKey: "g1" },
  { id: 13, src: "/images/g2.jpg", captionKey: "g2" },
  { id: 14, src: "/images/g3.jpg", captionKey: "g3" },
  { id: 15, src: "/images/g6.jpg", captionKey: "g6" },
];

export const INSTRUCTORS = [
  {
    id: 1,
    name: "Renchi Cristobal Azpilcueta",
    location: "Melrose Park, IL 60160",
    phone: "(708) 705-7004",
    image: "/images/logo.jpg",
  },
  {
    id: 2,
    name: "Renchi Daniel Azpilcueta",
    location: "3039 W 59th St, Chicago, IL 60629",
    phone: "708-612-0023",
    image: "/images/logo.jpg",
  },
  {
    id: 3,
    name: "Eulando Rhone",
    location: "2156 W Cermak Rd, Chicago, IL 60608",
    phone: "(708) 612-0023",
    image: "/images/logo.jpg",
  },
];

export const LOCATIONS = [
  { id: 1, address: "3039 W 59th St, Chicago IL 60629" },
  { id: 2, address: "1810 W Lake St, Melrose Park IL 60160" },
  { id: 3, address: "2156 W Cermak Rd, Chicago IL 60608" },
];

export const REVIEWS = [
  { id: 1, name: "Maria Olivia Navarro", time: "8 years ago", rating: 5, text: "Our Dojo since my Lil Guy was 4. Excellent attention to kids!" },
  { id: 2, name: "Cristal Martinez", time: "5 years ago", rating: 5, text: "Love the attention and patience they have with kids." },
  { id: 3, name: "Daniel Samano", time: "2 years ago", rating: 5, text: "Good good environment for the kids." },
  { id: 4, name: "Tania Rosales", time: "4 years ago", rating: 5, text: "Excelente" },
  { id: 5, name: "Flora Baltazar", time: "4 years ago", rating: 5, text: "My son loves it and is learning discipline and self defense when to use it and when not too. Great people." },
  { id: 6, name: "Ramon Rivera", time: "2 years ago", rating: 5, text: "Very great place! Excellent for self defense and the patience others have there. 100% recommended!" },
  { id: 7, name: "Erika Lucena", time: "1 year ago", rating: 5, text: "Muy buena escuela. Mi hija asiste allí. Los maestros tienen calidad humana. 100% recomendada." },
  { id: 8, name: "Fabiola Romero", time: "4 years ago", rating: 5, text: "Excelente profesor. Se nota el cambio que les ayuda la disciplina. 1000% recomendable." },
  { id: 9, name: "Armando Bucio", time: "8 years ago", rating: 5, text: "Very good place to learn Karate for kids and adults. The best senseis, very good family." },
  { id: 10, name: "Bella Flores", time: "3 years ago", rating: 5, text: "Love it. You meet great people and learn self defense. Definitely recommend." },
];

export const ABOUT_TEXT = [
  "Yoshitaka is a network of Karate schools (dojos) serving the Chicagoland area. We are proud to teach the traditional art of Karate in a supportive and encouraging environment where every student can thrive. Our classes focus on building confidence, discipline, fitness, and self-defense skills while keeping the spirit of Karate alive.",
  "We welcome students of all ages and skill levels, from children taking their first class to adults continuing their martial arts journey. At Yoshitaka, families and individuals alike will find a positive community that values respect, growth, and the joy of learning Karate together.",
];
